// Footer.js
import React from 'react';
import { Box, Typography } from '@mui/material';
import './../App.css';

const Footer = ({ sidebarExpanded }) => (
  <Box
    className={
      sidebarExpanded
        ? 'sidebar-expanded footer-container'
        : 'sidebar-collapsed footer-container'
    }
    sx={{
      backgroundColor: '#f5f5f5',
      py: 2,
      px: 2,
      mt: 'auto',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
    }}
  >
    <Typography variant="body2" align="center">
      Developed by <strong>Smart Stable</strong> — © Nudrah Stud 2025
    </Typography>
  </Box>
);

export default Footer;
